import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { VehicleSummaryStyled } from '../../VehicleSummaryStyled';
import { rem } from 'polished';

export const VehicleSummaryStyledOV = styled(VehicleSummaryStyled)`
    .summary-price-container {
        padding-top: ${rem('15.5px')};
        padding-bottom: ${rem('15.5px')};
        border-top: 1px solid ${({ theme }) => theme.colors.grey16};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};

        .content {
            .header {
                .catalog-price-title {
                    border-top: unset;
                    border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};
                }
            }
            .body {
                .body-wrapper {
                    font-family: ${({ theme }) => theme.fonts.fontSecondary};
                    .price {
                        font-size: ${rem(20)};
                    }

                    .totalMonthlyPriceWrapper {
                        align-items: flex-end;
                    }

                    .financeContainer-price-financeQuoteLink {
                        font-size: ${rem('14px')};
                    }
                }
            }
        }
    }

    .benefits {
        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.black} !important;
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }

                path {
                    fill: ${({ theme }) => theme.colors.white} !important;
                }
            }
        }
    }

    .offerValidityDate {
        border-color: ${({ theme }) => theme.colors.grey16};
    }

    .show-characteristics-button {
        font-size: ${rem(16)};
    }

    .benefits-wrapper {
        background: ${({ theme }) => theme.colors.white};
        margin-top: ${rem(25)};
    }

    span.title {
        font-size: ${rem('16px')};
        padding: ${rem('31px')} 0 ${rem('31px')} 0;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .benefits {
        margin: ${rem(15)} ${rem(15)} ${rem(10)} ${rem(15)};

        .bullet-points.allow-bullet-points {
            padding: 0 ${rem(16)};
        }
    }
`;
